
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  GetDictionary,
  GetDictionaryData,
  PostAddDictionary,
  PatchEditDictionary,
  DelDictionary,
} from "@/request/common";
import Empty from "@/components/empty.vue";
@Component({
  components: {
    Empty,
  },
})
export default class Name extends Vue {
  @Prop()
  private type: any;
  @Prop()
  private ifShow: any;
  @Watch("ifShow", { immediate: true })
  private ifShowChange() {
    this.ifShowManage = this.ifShow;
    if (this.ifShow) {
      this.getData();
      this.getParent();
    }
  }
  private ifShowManage: any = false;
  private options: any = [];
  private data: any = [];
  private current: any = {};
  private parent: any = "";
  private cancel() {
    this.$emit("cancel");
  }
  private getParent() {
    const params: any = {
      params: {
        value: this.type,
      },
    };
    GetDictionary(this, params).then((res: any) => {
      if (res.data.length > 0) {
        this.parent = res.data[0].id;
      } else {
        this.$message.warning(this.type + "不存在，请先去后台创建");
      }
    });
  }
  private addOne() {
    if (this.current.id) {
      this.$message.warning("请先保存修改的内容");
      return;
    }
    const obj = {
      id: "add",
      value: "",
    };
    this.data.push(obj);
    this.current = obj;
  }
  private edit(item: any) {
    if (this.current.id) {
      this.$message.warning("请先保存修改的内容");
      return;
    }
    this.current = item;
    this.$forceUpdate();
  }
  private save(item: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (!this.parent) {
      this.$message.warning(this.type + "不存在,请去后台添加");
      return;
    }
    if (item.id == "add") {
      const params: any = {
        parent: this.parent,
        value: item.value,
        label: item.value,
        status: true,
      };
      PostAddDictionary(this, params, loading).then((res: any) => {
        item.id = res.data.id;
        this.current = {};
        this.$emit("change");
      });
    } else {
      const params: any = {
        parent: this.parent,
        value: item.value,
        label: item.value,
      };
      PatchEditDictionary(this, item.id, params, loading).then((res: any) => {
        this.current = {};
        this.$emit("change");
      });
    }
  }
  private delOne(item: any, index: any) {
    this.$confirm("您是否确定删除？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      if (item.id == "add") {
        this.data.splice(index, 1);
      } else {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        DelDictionary(this, item.id, loading).then((res: any) => {
          this.data.splice(index, 1);
          this.$emit("change");
        });
      }
      // 如果删除的是当前编辑的，需要重置current
      if (item.id == this.current.id) {
        this.current = {};
      }
    });
  }
  private getData() {
    const params: any = {
      params: {
        values: this.type,
        statue: true,
      },
    };
    GetDictionaryData(this, params).then((res: any) => {
      this.data = res.data;
    });
  }
}
